import React, { useState } from 'react';
import TabsV2 from '../../../../components/TabsV2/Tabsv2';
import { PROMO_TABS, PROMO_TYPE } from './constants';
import PromoForm from './Elements/OrderLevelForm';

function PromosAndCoupons() {
  const [activeTab, setActiveTab] = useState(PROMO_TYPE.ORDER_LEVEL);

  return (
    <div className='tw-flex tw-w-full tw-flex-col tw-gap-10 tw-bg-white tw-p-8 tw-rounded-2xl tw-h-max'>
      <h1 className='tw-text-[2rem] tw-font-medium tw-text-zinc-800 tw-m-0'>
        Create Promos
      </h1>
      <TabsV2
        tabs={PROMO_TABS}
        activeKey={activeTab}
        onChange={setActiveTab}
        variant='pill'
        size='lg'
      />

      <PromoForm promoType={activeTab} />
    </div>
  );
}

export default PromosAndCoupons;
